<template lang='pug'>
#container
  router-view
</template>

<style lang='sass'>
@import '../variables'

@page
  size: US-Letter
  margin: 0 0 35mm 0
  background: #ffffff
  font-size: 16px

body
  border-top: 10px solid $colorMenu
  font-size: 16px
  font-family: "myriad-pro-1", "myriad-pro-2", sans-serif

*
  box-sizing: border-box

// Reference: https://stackoverflow.com/questions/320357/safe-width-in-pixel-for-printing-web-pages
#container
  margin: 0 auto
  max-width: 8.5in
  padding-bottom: 10mm

table.el-table__header, table.el-table__body
  max-width: 100% !important

</style>

<script>
  export default {
    components: { }
  }
</script>



// WEBPACK FOOTER //
// src/layout/PrintLayout.vue